module.exports = __webpack_public_path__ + "static/img/two.1e540ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bulk-order/two.png
// module id = MZAk
// module chunks = 1